import AuthReducer from "./AuthReducer";
import { createContext, useEffect, useReducer } from "react";

const INITIAL_STATE = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  isFetching: false,
  error: false,
  errorMessage: "",
  shop: JSON.parse(localStorage.getItem("shop")) || null,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(state.user));
    localStorage.setItem("shop", JSON.stringify(state.shop));
  }, [state.user, state.shop]);

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        isFetching: state.isFetching,
        error: state.error,
        errorMessage: state.errorMessage,
        shop: state.shop,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
